/** Parsed reference to a Netlify site (slug, API id, or deploy URL). */
export type NetlifySiteRef =
  | { kind: 'site_id'; value: string }
  | { kind: 'slug'; value: string };

const SITE_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const SLUG_RE = /^[a-z0-9][a-z0-9-]*$/i;

/** Normalize user input (site URL, admin link, slug, or site API id). */
export function parseNetlifySiteRef(input: string): NetlifySiteRef | null {
  const raw = input.trim();
  if (!raw) return null;

  if (SITE_ID_RE.test(raw)) return { kind: 'site_id', value: raw };

  const asUrl = raw.includes('://') ? raw : `https://${raw}`;
  try {
    const u = new URL(asUrl);
    const appHost = u.hostname === 'app.netlify.com' || u.hostname === 'www.app.netlify.com';
    if (appHost) {
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.findIndex(p => p === 'sites' || p === 'projects');
      if (idx >= 0 && parts[idx + 1]) {
        const slug = parts[idx + 1]!.toLowerCase();
        if (SLUG_RE.test(slug)) return { kind: 'slug', value: slug };
      }
    }

    const deployHost = u.hostname.match(/^([a-z0-9][a-z0-9-]*)\.netlify\.app$/i);
    if (deployHost) return { kind: 'slug', value: deployHost[1]!.toLowerCase() };
  } catch {
    /* not a URL */
  }

  const slug = raw.toLowerCase();
  if (SLUG_RE.test(slug)) return { kind: 'slug', value: slug };
  return null;
}
